import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { initReactI18next } from 'react-i18next'
import { HydratedRouter } from 'react-router/dom'
import { getInitialNamespaces } from 'remix-i18next/client'
import i18n from './i18n'

async function hydrate() {
	// Initialize i18next on the client side
	await i18next
		.use(initReactI18next)
		.use(LanguageDetector)
		.use(Backend)
		.init({
			...i18n,
			lng: 'nl', // Default to Dutch
			ns: getInitialNamespaces(),
			backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
			detection: {
				// Get language from HTML tag first (set by server)
				order: ['htmlTag', 'cookie', 'localStorage', 'navigator'],
				caches: ['cookie'],
			},
		})

	startTransition(() => {
		hydrateRoot(document, <HydratedRouter />)
	})
}

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

void hydrate()
